var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiChatbot = function SvgAiChatbot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31,
    r: 12,
    fill: "#00C8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09677 16.184C3.79994 16.184 3.54151 16.3901 3.48792 16.682C2.83051 20.2635 3.54876 24.1236 5.76238 27.444C5.85645 27.5851 5.89359 27.7573 5.86183 27.9239L4.84897 33.2361C4.78658 33.5633 4.90032 33.8992 5.14864 34.1213C5.39696 34.3433 5.74351 34.4189 6.06174 34.3204L11.3254 32.6916C11.483 32.6429 11.6537 32.6584 11.8018 32.731C17.7943 35.6699 24.9758 34.4645 29.3654 29.6447L29.3657 29.6443C34.7816 23.6911 34.0437 14.4299 27.828 8.95918C27.828 8.95917 27.828 8.95916 27.828 8.95916C27.828 8.95915 27.828 8.95914 27.828 8.95913L27.8222 8.95416C25.3807 6.8397 22.4209 5.58962 19.3914 5.24133C19.0269 5.19942 18.7155 5.49058 18.7155 5.85752V6.49804C18.7155 6.82786 18.9691 7.10074 19.2965 7.14127C21.9053 7.46435 24.4576 8.55222 26.5768 10.3865C32.0485 15.205 32.6151 23.252 27.9617 28.367C24.0499 32.6619 17.5015 33.6851 12.1193 30.7591C11.8945 30.6369 11.6299 30.6106 11.3855 30.6862L8.01485 31.7292C7.55896 31.8703 7.11696 31.4751 7.20634 31.0063L7.85178 27.6212C7.90107 27.3626 7.84079 27.0952 7.68533 26.8829C5.46808 23.8539 4.74399 20.2737 5.36312 16.981C5.43955 16.5745 5.13756 16.184 4.72395 16.184H4.09677Z",
    fill: "#005269"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5211 19.7588C14.5335 20.671 13.8034 21.4225 12.8912 21.435C11.979 21.4475 11.2275 20.7174 11.215 19.8052C11.2025 18.893 11.9326 18.1414 12.8448 18.1289C12.852 18.1289 12.8609 18.1289 12.868 18.1289C13.7749 18.1236 14.5139 18.8519 14.5211 19.7588Z",
    fill: "#005269"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7808 19.7588C19.7933 20.671 19.0632 21.4225 18.151 21.435C17.2388 21.4475 16.4873 20.7174 16.4748 19.8052C16.4623 18.893 17.1924 18.1415 18.1046 18.129C18.1117 18.129 18.1207 18.129 18.1278 18.129C19.0346 18.1218 19.7737 18.8501 19.7808 19.757C19.7808 19.757 19.7808 19.757 19.7808 19.7588Z",
    fill: "#005269"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0416 19.7588C25.0541 20.671 24.3239 21.4225 23.4117 21.435C22.4995 21.4475 21.748 20.7174 21.7355 19.8052C21.723 18.893 22.4531 18.1414 23.3653 18.1289C23.3725 18.1289 23.3814 18.1289 23.3885 18.1289C24.2954 18.1236 25.0344 18.8519 25.0416 19.7588Z",
    fill: "#005269"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0543 9.91443L8.63957 16.1846L7.1683 9.88421L1.00026 8.55464L6.96458 7.28853L8.54526 1.00026L10.0165 7.30062L16.1846 8.63019L10.0543 9.91443Z",
    fill: "white",
    stroke: "#005269",
    strokeWidth: 1.89804,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
};
export default SvgAiChatbot;